<template>
  <DataTableAsync class="mt-3" :data="tableData" v-model="tableState" :length="(documents || []).length" :isLoading="isLoading" noSearch ref="dataTable">
    <template #head>
      <tr>
        <Th prop="fileName" sort>File Name</Th>
        <Th prop="category" sort>Category</Th>
        <Th prop="description" sort>Description</Th>
        <Th prop="uploadDate" sort>Expiration Date</Th>
        <Th prop="uploadDate" sort>Upload Date</Th>
        <th />
      </tr>
    </template>
    <template #body="{ item }">
      <tr>
        <td>
          <div class="clickable" @click="openDocument(item)" v-if="item.id">
            {{ item.fileName }}
          </div>
          <div v-else>
            {{ item.fileName }}
          </div>
        </td>
        <td>{{ categoryName(item.categoryId) }}</td>
        <td>{{ item?.description }}</td>
        <td>{{ dateFormat(item.expirationDate) || '-' }}</td>
        <td>{{ browserDate(item.uploadDate) || '-' }}</td>
        <td class="text-center">
          <v-icon @click="$emit('remove', item)" v-if="hasRemove">mdi-close</v-icon>
        </td>
      </tr>
    </template>
  </DataTableAsync>
</template>

<script>
import axios from '../../axios';
import DataTableAsync from '../../components/common/dataTable/DataTableAsync.vue'
import Th from '../../components/common/dataTable/Th.vue'
import { errorDebug } from '../../libraries/common';

export default {
  components: { DataTableAsync, Th, },
  props: ['documents',],
  data() {
    return {
      tableState: { page: 1, perPage: 25 },
      categories: [],
      isLoading: false,
    };
  },
  computed: {
    tableData() {
      return this.documents
        .skip(this.tableState.perPage * (this.tableState.page - 1))
        .take(this.tableState.perPage);
    },
    hasRemove() {
      return this.$listeners.remove;
    },
  },
  methods: {
    categoryName(categoryId) {
      var category = this.categories.find(f => f.id === categoryId);
      return category?.name;
    },
    openDocument(item) {
      axios.get(`/api/ITM/Documents/${item.id}`)
        .then(({ data }) => window.open(data, '_blank'))
        .catch(errorDebug);
    },
    getCategories() {
      this.isLoading = true;
      axios.get(`/api/ITM/DocumentCategories`)
        .then(({ data }) => this.categories = data)
        .catch(errorDebug)
        .then(() => this.isLoading = false);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisITMDocuments'] = this;
    this.getCategories();
  },
}
</script>